import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { Colors } from "../utils/style";
import {
  Alert,
  Button,
  Card,
  Carousel,
  Col,
  Container,
  Form,
  Placeholder,
  Row,
  Spinner,
} from "react-bootstrap";
import CardComponent from "./CardComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faObjectGroup, faThumbtack } from "@fortawesome/free-solid-svg-icons";
import { useStore } from "../store";
import axios from "axios";
import CodeCardComponent from "./CodeCardComponent";
import "./style.css";
import { GRAPHIMAGE } from "../utils/exploration";
import TableComponent from "./TableComponent";
import MyDropDown from "./MyDropDown";
import { useTranslation } from 'react-i18next';
import i18n from "../i18n";
import CreditModal from "./CreditModal";
import { axiosInstance } from "../App";

interface Props {
  fileName: string | null;
}

function ExplorationContainer(props: Props) {
  const { explanations, setExplanations } = useStore();
  const { summary, setSummary } = useStore();
  const { creditRiskTarget, setCreditRiskTarget } = useStore();
  const { analyse, setAnalyse } = useStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadError, setUploadError] = useState(false);

  const [index, setIndex] = useState(0);
  const { t } = useTranslation("ExplorationContainer");

  const exploreGhraph = GRAPHIMAGE;

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
  };

  function getAnalyse(target: string) {
    setCreditRiskTarget(target);
    const body = {
      summary: summary,
      target: target,
    };
    setLoading(true);
    axiosInstance
      .post(process.env.REACT_APP_API_HOST + "analyze", body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenLida"),
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        setAnalyse(response.data.analysis);
        setLoading(false);
        setUploadError(false);
      })
      .catch((error) => {
        setLoading(false);
        setUploadError(true);
        console.error("Error uploading file:", error);


        if (error.response && error.response.status === 402) {
          // Show payment modal
          setIsModalOpen(true);
        }
      });
  }

  return (
    <>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "1rem",
        }}
        className="mt-3"
      >
        <FontAwesomeIcon
          icon={faObjectGroup}
          size="2x"
          color={Colors.DARK_BLUE}
        />
        <div
          style={{
            textAlign: "left",
            fontSize: "25px",
            fontWeight: "bold",
            color: Colors.DARK_BLUE,
          }}
        >
          {t("ExploratoryDataAnalysis")}
        </div>
      </div>
      <div
        style={{
          textAlign: "left",
          fontSize: "18px",
          color: Colors.DARK_BLUE,
        }}
      >
        {
          t("ExploratoryDataDescription")
        }
      </div>
      <div>
        <CardComponent backgroundColor={Colors.LIGHT_BLUE}>
          {/* <Button onClick={() => getAnalyse("price")}>Start Analayse</Button> */}
          {loading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <Spinner animation="grow" variant="success" />
              <Placeholder xs={12} size="lg" bg="light" />
              <Placeholder xs={12} size="lg" bg="light" />
              <Placeholder xs={12} size="lg" bg="light" />
              <Placeholder xs={12} size="lg" bg="light" />
              <Placeholder xs={12} size="lg" bg="light" />
              <Placeholder xs={12} size="lg" bg="light" />
            </div>
          ) : analyse ? (
            <Carousel
              activeIndex={index}
              onSelect={handleSelect}
              variant="dark"
              interval={null}
            >
              {/* <Carousel.Item>
              <Container className=" p-5">
                <Row md={2} xs={2} lg={2} sm={2}>
                  {explanations?.map((item) => (
                    <>
                      <Col style={{ padding: "0.5rem" }}>
                        <CardComponent
                          title={item.section || undefined}
                          description={item.explanation}
                        ></CardComponent>
                      </Col>
                      <Col style={{ padding: "0.5rem" }}>
                        <CodeCardComponent
                          title="code"
                          code={item.code}
                        ></CodeCardComponent>
                      </Col>
                    </>
                  ))}
                </Row>
              </Container>
            </Carousel.Item> */}

              {Object.keys(analyse as Object).map((key) => (
                <Carousel.Item>
                  <div
                    style={{
                      display: "flex",
                      gap: "3rem",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <FontAwesomeIcon icon={faThumbtack} />
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: Colors.DARK_BLUE,
                        }}
                      >
                        {t("Variable") + key}
                      </div>
                    </div>
                    <MyDropDown
                      onClick={getAnalyse}
                      options={summary?.boolean_fields}
                      title={t("SelectTarget")}
                    ></MyDropDown>
                  </div>
                  <Container
                    style={{
                      paddingLeft: "2.5rem",
                      paddingRight: "2.5rem",
                      paddingTop: "0.5rem",
                      paddingBottom: "2.5rem",
                    }}
                  >
                    <Row md={1} xs={1} lg={1} sm={1}>
                      <Col style={{ padding: "0.5rem" }}>
                        <CardComponent title={t("Graph")}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              maxHeight: "30rem",
                            }}
                          >
                            <div
                              style={{
                                overflowX: "auto",
                              }}
                            >
                              <img
                                src={`data:image/jpeg;base64, ${analyse[key].graph}`}
                              />
                            </div>
                          </div>
                        </CardComponent>
                      </Col>
                      <Col style={{ padding: "0.5rem" }}>
                        <CardComponent
                          title={t("GraphAnalysis")}
                          description={
                            analyse[key]?.interpretation?.graphAnalysis
                          }
                        ></CardComponent>
                      </Col>
                      <Col style={{ padding: "0.5rem" }}>
                        <CardComponent title={t("Metrics")}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              maxHeight: "40rem",
                            }}
                          >
                            <div
                              style={{
                                overflowX: "auto",
                              }}
                            >
                              <TableComponent
                                headers={Object.keys(
                                  analyse[key]?.metrics as Object
                                )}
                                data={{ [key]: analyse[key]?.metrics }}
                              ></TableComponent>
                            </div>
                          </div>
                        </CardComponent>
                      </Col>

                      <Col style={{ padding: "0.5rem" }}>
                        <CardComponent
                          title={t("MetricsAnalysis")}
                          description={
                            analyse[key]?.interpretation?.metricsAnalysis
                          }
                        ></CardComponent>
                      </Col>
                    </Row>
                    <Row>
                      <Col style={{ padding: "0.5rem" }} slot="2">
                        <CardComponent
                          title={t("Conclusion")}
                          description={
                            analyse[key]?.interpretation?.conclusions
                          }
                        ></CardComponent>
                      </Col>
                    </Row>
                  </Container>
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <div
              style={{
                display: "flex",
                gap: "3rem",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <MyDropDown
                onClick={getAnalyse}
                options={summary?.boolean_fields}
                title={t("SelectTarget")}
              ></MyDropDown>
            </div>
          )}
        </CardComponent>
      </div>
    </div>


    </>
  );
}

export default ExplorationContainer;
